import { render } from "./SolicitarAcesso.vue?vue&type=template&id=0bc7797c&scoped=true"
import script from "./SolicitarAcesso.vue?vue&type=script&lang=js"
export * from "./SolicitarAcesso.vue?vue&type=script&lang=js"

import "./SolicitarAcesso.vue?vue&type=style&index=0&id=0bc7797c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc7797c"]])

export default __exports__